module.exports = __webpack_public_path__ + "img/gsgc2902_1.0d13c06d.svg";